export default {
  isValidName: (name) => {
    const pattern = /[^A-Za-z0-9 .,'"*-]/;
    const valid = !pattern.test(name);
    return valid;
  },

  isValidEmail: (email) => {
    const regex = "";
    const email_regex= "a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,80}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,80}[a-zA-Z0-9])?";
    const combine_regex = `${regex}${email_regex}`;
    let pattern = new RegExp(`^[${combine_regex})*$`);

    const valid = pattern.test(email);
    return valid;
  },

  isValidEmailCharacters: (email) => {
    const pattern = /^[A-Za-z0-9.\-@_]+$/;
    const valid = pattern.test(email);
    return valid;
  },

  isValidMobileNumber: (mobileNumber) => {
    const pattern = /^09\d{9}$/;
    const mobile = mobileNumber.replace("+63", "0")
    const valid = pattern.test(mobile);
    return valid;
  },

  isValidMobileNumberV2: (mobileNumber) => {
    const pattern = /^09\d{10}$/;
    // const mobile = mobileNumber.replace("+63", "0")
    const valid = pattern.test(mobileNumber);
    return valid;
  },

  isValidDigit: (digit) => {
    const pattern = /^[0-9]+$/;
    const valid = pattern.test(digit);
    return valid;
  },

  isValidMobileString: (digit) => {
    const pattern = /^[0-9\+\(\)]+$/;
    const valid = pattern.test(digit);
    return valid;
  },

  isValidIDNumber: (number, allowedSpecialChars, isNumeric = false) => {
    const numericPattern = new RegExp(`^[0-9${allowedSpecialChars}]+$`);
    const alphanumericPattern = new RegExp(`^[A-Za-z0-9${allowedSpecialChars}]+$`);
    const valid = isNumeric ? numericPattern.test(number) : alphanumericPattern.test(number);
    return valid;
  },

  isValidString: (value, allowedCharacters) => {
      let regex = "";
      const allowSpaces = true;
      const allowLetters = true;
      const allowNumbers = true;
      const numerics = "0-9";
      const alphabets = "A-Za-z";

      if (allowLetters) regex = `${regex}${alphabets}`;
      if (allowNumbers) regex = `${regex}${numerics}`;
      if (allowSpaces) regex = `${regex} `;
      if (allowedCharacters) regex = `${regex}${allowedCharacters}`;

      const pattern = new RegExp(`^[${regex}]+$`);
      const valid = pattern.test(value);

      console.log(value)
      return valid;
    },
};
